import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b65365f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ModalListGroup_Header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ModalListGroup_Header_Title" }, "注文リスト一覧 ", -1))
const _hoisted_3 = { class: "ModalListGroup_Main" }
const _hoisted_4 = { class: "SearchDetail" }
const _hoisted_5 = { class: "form_wrapper" }
const _hoisted_6 = { class: "Flex_Wrapper" }
const _hoisted_7 = { class: "Flex_Child_Half" }
const _hoisted_8 = { class: "Flex_Child_Half" }
const _hoisted_9 = { class: "Flex_Wrapper" }
const _hoisted_10 = { class: "Flex_Child_Half" }
const _hoisted_11 = { class: "Search_Contents" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "Search_Contents_Title" }, "表示期間", -1))
const _hoisted_13 = { class: "Search_Contents_List" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"30px"} }, "～", -1))
const _hoisted_15 = { class: "check_container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contain_mukigen" }, "無期限を含む", -1))
const _hoisted_17 = { class: "check_container" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "contain_expired" }, "表示期間外を含む", -1))
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "ModalListGroup_TableContainer" }
const _hoisted_21 = { class: "ModalListGroup_operationWrapper" }
const _hoisted_22 = { class: "paging_container" }
const _hoisted_23 = { class: "ModalListGroup_Table" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "選択"),
    /*#__PURE__*/_createElementVNode("th", null, "画像"),
    /*#__PURE__*/_createElementVNode("th", null, [
      /*#__PURE__*/_createTextVNode("リスト名"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("説明")
    ]),
    /*#__PURE__*/_createElementVNode("th", null, "表示期間"),
    /*#__PURE__*/_createElementVNode("th", null, "登録日"),
    /*#__PURE__*/_createElementVNode("th", null, "登録者")
  ])
], -1))
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "img_td" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "title_td" }
const _hoisted_29 = { class: "list_name" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 0,
  class: "ResultMessageNull"
}

import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { useRouter } from "vue-router";
import Paginate from "vuejs-paginate-next";
import searchInputSyosi from "../molecules/searchInputSyosi.vue";
import searchInputDate from "../molecules/searchInputDate.vue";

export type Lists = typeof search_result.value[0];


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalListGroup',
  emits: ["close", "updatedCart", "deleteItem", "selectList"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const router = useRouter();
const emit = __emit;
const closeModal = () => {
  emit("close");
};

// 検索入力関連--------------------------------------------------
const searchConditions = ref({
  freeword: "",
  syosiCd: "",
  fromRegisterDate: "",
  toRegisterDate: "",
  fromDisplayDate: "",
  toDisplayDate: "",
  containsMukigen: false,
  isExpired: false,
});
// 条件リセット
const resetConditions = () => {
  searchConditions.value.freeword = "";
  searchConditions.value.syosiCd = "";
  searchConditions.value.fromRegisterDate = "";
  searchConditions.value.toRegisterDate = "";
  searchConditions.value.fromDisplayDate = "";
  searchConditions.value.toDisplayDate = "";
  searchConditions.value.containsMukigen = false;
  searchConditions.value.isExpired = false;
};

// 検索
const onSearch = async () => {
  currentPage.value = 1;
  await getData();
};

// データ取得----------------------------------------------------
// 1ページあたりの表示データ数(一旦固定)
let dataPerPage = 50;
const search_result = ref([
  {
    hanmotoCd: null as string | null,
    userId: null as string | null,
    userName: "",
    listId: -1,
    imageUrl: "",
    listName: "",
    description: "",
    registerDate: "",
    startDate: "",
    endDate: "",
    syosiList: null,
    expired: false,
  },
]);
const getData = async () => {
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/compile/list-display-in-normal?freeword=${searchConditions.value.freeword}&syosiCd=${searchConditions.value.syosiCd}&userId=${store.getters["login/getUserData"].userId}&fromRegisterDate=${searchConditions.value.fromRegisterDate}&toRegisterDate=${searchConditions.value.toRegisterDate}&fromDisplayDate=${searchConditions.value.fromDisplayDate}&toDisplayDate=${searchConditions.value.toDisplayDate}&containsMukigen=${searchConditions.value.containsMukigen}&shouldDisplayExpired=${searchConditions.value.isExpired}&page=${currentPage.value}&numberOfDisplay=${dataPerPage}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    numberOfTotalData.value = res.data.size;
    firstCount.value = res.data.firstCount;
    finalCount.value = res.data.finalCount;
    search_result.value.splice(0);
    search_result.value = res.data.compiledSyosiList;
    getTotalPage();
  } catch (error) {
    console.log(error);
    alert("リストデータを取得できませんでした");
  }
};
onMounted(() => {
  getData();
});

// 日付を表示用に変換--------------------------------------------
const convertDate = (date: string | null) => {
  if (typeof date === "string") {
    const targetDate = new Date(date);
    const year = targetDate.getFullYear();
    const month = targetDate.getMonth() + 1;
    const day = targetDate.getDate();
    return year + "/" + month + "/" + day;
  } else {
    return null;
  }
};
// ページネーション関連処理-----------------------------------------
// 取得データ合計
let numberOfTotalData = ref(0);
//表示中のページ範囲
let firstCount = ref(0);
let finalCount = ref(0);
// 総ページ数
const numberOfTotalPage = ref(0);
// 現在のページ数
const currentPage = ref(1);
const getTotalPage = () => {
  numberOfTotalPage.value = Math.ceil(numberOfTotalData.value / dataPerPage);
};
const onClickPage = (newPage: number) => {
  currentPage.value = newPage;
  getData();
};

// 選択----------------------------------------
const selectList = (event: any, list: Lists) => {
  emit("selectList", list);
  event.stopPropagation();
};
// 詳細表示------------------------------------
const clickSyosi = (listId: number) => {
  let resolvedRoute = router.resolve({
    name: "CreateNewList",
    params: { id: listId },
  });
  window.open(resolvedRoute.href);
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "ModalListGroup",
      onClick: closeModal
    }),
    _createElementVNode("div", {
      onKeydown: _withKeys(onSearch, ["enter"]),
      class: "ModalListGroup_Content"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_font_awesome_icon, {
          onClick: closeModal,
          class: "ModalListGroup_Header_Close",
          icon: "xmark"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", null, [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "書名, ISBN, 著者名等を入力",
                class: "SearchSimple_Input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchConditions.value.freeword) = $event))
              }, null, 512), [
                [_vModelText, searchConditions.value.freeword]
              ]),
              _createElementVNode("button", {
                onClick: onSearch,
                class: "common_btn btn_green"
              }, " 検索 "),
              _createElementVNode("button", {
                onClick: resetConditions,
                class: "common_btn btn_gray"
              }, " 条件リセット ")
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(searchInputSyosi, {
                  title: '商品コード',
                  initialData: searchConditions.value.syosiCd,
                  onChange: _cache[1] || (_cache[1] = 
                    (newVal) => (searchConditions.value.syosiCd = newVal.syosiCd)
                  )
                }, null, 8, ["initialData"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(searchInputDate, {
                  title: '登録日',
                  initialFromData: searchConditions.value.fromRegisterDate,
                  initialToData: searchConditions.value.toRegisterDate,
                  onChange: _cache[2] || (_cache[2] = 
                    (newFrom, newTo) => (
                      (searchConditions.value.fromRegisterDate = newFrom),
                      (searchConditions.value.toRegisterDate = newTo)
                    )
                  )
                }, null, 8, ["initialFromData", "initialToData"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("li", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchConditions.value.fromDisplayDate) = $event))
                    }, null, 512), [
                      [_vModelText, searchConditions.value.fromDisplayDate]
                    ]),
                    _hoisted_14,
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchConditions.value.toDisplayDate) = $event))
                    }, null, 512), [
                      [_vModelText, searchConditions.value.toDisplayDate]
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchConditions.value.containsMukigen) = $event)),
                        type: "checkbox",
                        name: "contain_mukigen",
                        id: "contain_mukigen"
                      }, null, 512), [
                        [_vModelCheckbox, searchConditions.value.containsMukigen]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((searchConditions.value.isExpired) = $event)),
                        type: "checkbox",
                        name: "contain_expired",
                        id: "contain_expired",
                        disabled: 
                          searchConditions.value.fromDisplayDate !== '' &&
                          searchConditions.value.toDisplayDate !== ''
                        
                      }, null, 8, _hoisted_19), [
                        [_vModelCheckbox, searchConditions.value.isExpired]
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_unref(Paginate), {
                "page-count": numberOfTotalPage.value,
                "hide-prev-next": true,
                "page-range": 3,
                "prev-text": '<',
                "next-text": '>',
                "container-class": 'pagination',
                "page-class": 'page-item',
                "page-link-class": 'page-item--link',
                "active-class": 'page-item--active',
                "click-handler": onClickPage,
                "force-page": currentPage.value
              }, null, 8, ["page-count", "force-page"]),
              _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(numberOfTotalData)) + "件/" + _toDisplayString(_unref(firstCount)) + "～" + _toDisplayString(_unref(finalCount)) + "件を表示", 513), [
                [_vShow, search_result.value.length]
              ])
            ])
          ]),
          _createElementVNode("table", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(search_result.value, (result, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (selectList($event, result)),
                      class: "ModalListGroup_Table_Button"
                    }, " 選択 ", 8, _hoisted_25)
                  ]),
                  _createElementVNode("td", _hoisted_26, [
                    (result.imageUrl === null)
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          icon: "image",
                          class: "img_icon"
                        }))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: `data:image;base64,${result.imageUrl}`
                        }, null, 8, _hoisted_27))
                  ]),
                  _createElementVNode("td", _hoisted_28, [
                    _createElementVNode("p", _hoisted_29, [
                      _createElementVNode("a", {
                        onClick: ($event: any) => (clickSyosi(result.listId))
                      }, _toDisplayString(result.listName), 9, _hoisted_30)
                    ]),
                    _createElementVNode("p", null, _toDisplayString(result.description), 1)
                  ]),
                  _createElementVNode("td", null, [
                    (
                        result.startDate === null &&
                        result.endDate === '9999-12-31'
                      )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, "無期限"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(convertDate(result.startDate)) + "～" + _toDisplayString(convertDate(result.endDate)), 1))
                  ]),
                  _createElementVNode("td", null, _toDisplayString(convertDate(result.registerDate)), 1),
                  _createElementVNode("td", null, _toDisplayString(result.userName), 1)
                ]))
              }), 128))
            ])
          ]),
          (!search_result.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, " ※作成されたリストはありません "))
            : _createCommentVNode("", true)
        ])
      ])
    ], 32)
  ]))
}
}

})